import { useEffect, useState } from "react";
import { useAppSession } from "../context/AppSessionContext";
import { getCachedAppSettings } from "../helper/settingsCache";

/**
 * Widgets list — loaded once per tab via AppSessionProvider, not on each route.
 */
export function useWidgetsFromSession() {
  const { widgets, setWidgets, sessionReady, sessionLoading, refreshFromCache } = useAppSession();
  return { widgets, setWidgets, loading: sessionLoading && !sessionReady, refreshFromCache };
}

function settingsToJson(customCss, customJs) {
  return JSON.stringify({ customCss: customCss || "", customJs: customJs || "" });
}

/**
 * Settings form state — synced from session cache only (no GET on route change).
 */
export function useSettingsFromSession(initialState) {
  const { settings, sessionReady, sessionLoading } = useAppSession();
  const [customCss, setCustomCss] = useState(initialState.customCss);
  const [customJs, setCustomJs] = useState(initialState.customJs);
  const [baselineJson, setBaselineJson] = useState(initialState.baselineJson);
  const [loading, setLoading] = useState(initialState.loading);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionReady) return;

    const data = settings || getCachedAppSettings() || { customCss: "", customJs: "" };
    const css = data.customCss || "";
    const js = data.customJs || "";
    setCustomCss(css);
    setCustomJs(js);
    setBaselineJson(settingsToJson(css, js));
    setLoading(false);
    setError(null);
  }, [sessionReady, settings]);

  return {
    customCss,
    setCustomCss,
    customJs,
    setCustomJs,
    baselineJson,
    setBaselineJson,
    loading: loading || (sessionLoading && !sessionReady),
    error,
    setError,
  };
}
